import { render, staticRenderFns } from "./DiscountCodeCreateAndUpdateFormItems.vue?vue&type=template&id=c94ca814&"
import script from "./DiscountCodeCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./DiscountCodeCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c94ca814')) {
      api.createRecord('c94ca814', component.options)
    } else {
      api.reload('c94ca814', component.options)
    }
    module.hot.accept("./DiscountCodeCreateAndUpdateFormItems.vue?vue&type=template&id=c94ca814&", function () {
      api.rerender('c94ca814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DiscountCodeCreateAndUpdateFormItems.vue"
export default component.exports